
/**
 * Module dependencies.
 */

import { createAction } from 'redux-actions'

/**
 * Actions.
 */

export const REQUEST_CURRENT_USER = 'REQUEST_CURRENT_USER'

/**
 * Request the current user.
 *
 * @return {Object}
 * @api public
 */

export const requestCurrentUser = createAction(REQUEST_CURRENT_USER)



// WEBPACK FOOTER //
// ./actions/current-user.js